import { useEffect, useRef } from 'react'

const map = (val: number, minA: number, maxA: number, minB: number, maxB: number): number => {
  return minB + ((val - minA) * (maxB - minB)) / (maxA - minA)
}

export const use3DEffect = <T extends HTMLElement>() => {
  const containerRef = useRef<T>(null)
  const cardRef = useRef<T>(null)

  const apply3DEffect = (e: MouseEvent) => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect()

      // Calculate mouseX and mouseY relative to cardContainer
      const mouseX = e.clientX - rect.left
      const mouseY = e.clientY - rect.top

      const rotateY = map(mouseX, 0, rect.width, -5, 5)
      const rotateX = map(mouseY, 0, rect.height, 5, -5)
      const brightness = map(mouseY, 0, rect.height, 1.2, 0.5)

      cardRef.current.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
      cardRef.current.style.filter = `brightness(${brightness})`
    }
  }

  useEffect(() => {
    const currentContainer = containerRef.current
    const currentCard = cardRef.current

    currentContainer?.addEventListener('mousemove', apply3DEffect)
    currentContainer?.addEventListener('mouseleave', () => {
      if (currentCard) {
        currentCard.style.transform = 'none'
        currentCard.style.filter = 'brightness(1)'
      }
    })

    return () => {
      currentContainer?.removeEventListener('mousemove', apply3DEffect)
      currentContainer?.removeEventListener('mouseleave', () => {
        if (currentCard) {
          currentCard.style.transform = 'none'
          currentCard.style.filter = 'brightness(1)'
        }
      })
    }
  }, [])

  return { containerRef, cardRef }
}
